// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SEO_DESCRIPTION_FORUM_category = "V\u0161etko o t\u00e9me %(category)s, \u010do mami\u010dky zauj\u00edma. Miesto pln\u00e9 sk\u00fasenost\u00ed, r\u00e1d, tipov a trikov priamo z prvej ruky.";
export const SEO_TITLE_FORUM_TOPICS_OF_category = "Kateg\u00f3rie z %(category)s";
